import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap 5
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css"; // DataTable Bootstrap 5 Styles
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; // DataTable Bootstrap 5 Responsive
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import * as XLSX from "xlsx"; // For exporting to Excel
import Header from "../Header";

const UserPayment = () => {
  const tableRef = useRef(null);
  const [transactions, setTransactions] = useState([]);
  const [plans, setPlans] = useState({}); // Object to store plans by id
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const id = localStorage.getItem('userId');

  // Fetch Transactions
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://apiaksharaconnect.aksharafinalytics.in/viewtransaction/${id}`
        );
        if (!response.ok) throw new Error("Network response was not ok");

        const result = await response.json();
       
        setTransactions(result || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Fetch Plans based on plan_ids from the transactions
  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await fetch(
          "https://apiaksharaconnect.aksharafinalytics.in/plans"
        );
        if (!response.ok) throw new Error("Network response was not ok");

        const result = await response.json();
        const plansMap = result.reduce((acc, plan) => {
          acc[plan.id] = plan.plan; // Assuming each plan has `id` and `name`
          return acc;
        }, {});

        setPlans(plansMap); // Store the plans by id
      } catch (error) {
        console.error("Error fetching plans:", error);
        setError(error.message);
      }
    };

    fetchPlans();
  }, []);

  // Initialize DataTable
  useEffect(() => {
    if (tableRef.current && transactions.length > 0) {
      const table = $(tableRef.current).DataTable({
        responsive: true,
        autoWidth: false,
        destroy: true,
        paging: true,
        pageLength: 10,
        lengthMenu: [10, 25, 50, 100],
        columnDefs: [
          { targets: 0, responsivePriority: 1 },
          { targets: 1, responsivePriority: 2 },
          { targets: 2, responsivePriority: 3 },
          { targets: 3, responsivePriority: 4 },
          { targets: 4, responsivePriority: 5 },
          { targets: 5, responsivePriority: 6 },
        ],
      });

      return () => {
        table.destroy(); // Cleanup on unmount
      };
    }
  }, [transactions]);

  // Export to Excel
  const exportToExcel = () => {
    if (transactions.length === 0) {
      alert("No data to export!");
      return;
    }
    const ws = XLSX.utils.json_to_sheet(transactions);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "transactions");
    XLSX.writeFile(wb, "Transactions_List.xlsx");
  };

  if (loading) return <div className="text-center mt-4">Loading...</div>;

  return (
    <>
      <Header />
      <div className="container-fluid mt-4">
        <div className="card shadow">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4>Transaction Management</h4>
            <button className="btn btn-success" onClick={exportToExcel}>
              Export to Excel
            </button>
          </div>
          <div className="card-body">
            {error && <div className="alert alert-danger">{error}</div>}

            {/* Responsive Table */}
            <div className="table-responsive">
              <table
                ref={tableRef}
                className="table table-striped table-bordered display nowrap"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th>S.no</th>
                    <th>Plan</th>
                    <th>Plan Type</th>
                    <th>Payment Mode</th>
                    <th>Payment Status</th>
                    <th>Amount</th>
                    <th>Date / Time</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions?.length > 0 ? (
                    transactions.map((transaction, index) => (
                      <tr key={transaction.id}>
                        <td>{index + 1}</td>
                        <td>{plans[transaction.plan_id] || "N/A"}</td> {/* Map plan_id to plan name */}
                        <td>{transaction.plan_type || "N/A"}</td>
                        <td>{transaction.payment_mode || "N/A"}</td>
                        <td>{transaction.paymentstatus || "N/A"}</td>
                        <td>₹ {transaction.paid_amount || "0.00"} /-</td>
                        <td>{transaction.dor || "N/A"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No transactions available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserPayment;
